// Dutch
export const nl = {
    weeklyRewards: 'Wekelijkse beloningen in',
    days: 'dagen',
    hours: 'uur',
    minutes: 'min',
    seconds: 'sec',
    authenticating: 'Authenticeren',
    verifyWallet: 'Even geduld terwijl we je portemonnee verifiëren',
    authRequired: 'Authenticatie vereist',
    authFailed: 'Authenticatie mislukt. Probeer het opnieuw.',
    points: 'Punten',
    rank: 'Rang',
    of: 'van',
    players: 'spelers',
    weeklyTopPlayers: 'Wekelijkse topspelers',
    thisWeekLeaderboard: 'Ranglijst deze week',
    rankingsReset: 'Ranglijst wordt elke zondag om middernacht UTC gereset',
    yourPoints: 'Jouw punten',
    dailyRewardAvailable: 'Dagelijkse beloning beschikbaar!',
    nextClaimAvailable: 'Volgende claim beschikbaar in:',
    claimDailyReward: 'Claim dagelijkse beloning',
    claiming: 'Claimen...',
    multiplier: 'Vermenigvuldiger',
    bonusPointsMultiplier: 'Bonuspunten vermenigvuldiger',
    outOf: 'van',
    loading: 'Laden...',
    errorLoading: 'Fout bij laden',
    noEntries: 'Nog geen vermeldingen',
    leaderboard: 'Ranglijst',
    tasks: 'Taken',
    rules: 'Regels',
    profile: 'Profiel',
    comingSoon: 'Binnenkort beschikbaar...',
    completedTasks: 'Voltooide taken',
    dailyRewardsClaimed: 'Geclaimde dagelijkse beloningen',
    times: 'keer',
    recentActivity: 'Recente activiteit',
    noRewardsClaimed: 'Nog geen beloningen geclaimd',
    dailyReward: 'Dagelijkse beloning',
    howItWorks: 'Hoe het werkt',
    welcomeMessage:
        'Welkom bij Coinomi Rewards! Verdien punten door verschillende taken te voltooien en klim op de ranglijst.',
    dailyRewardsTitle: 'Dagelijkse beloningen',
    dailyRewardsRules: [
        'Claim je dagelijkse beloning elke 24 uur',
        'Elke claim levert 100 punten op',
        'Punten worden vermenigvuldigd op basis van je vermenigvuldiger',
    ],
    multiplierBonusesTitle: 'Vermenigvuldiger bonussen',
    multiplierBonusesRules: [
        'Begin met 1x vermenigvuldiger',
        'Verbind Telegram voor +10% bonus',
        'Verifieer e-mail voor +10% bonus',
        'Bonussen stapelen voor maximale beloningen',
    ],
    leaderboardTitle: 'Ranglijst',
    leaderboardRules: [
        'Concurreer met andere spelers',
        'Ranglijst wordt realtime bijgewerkt',
        'Topspelers ontvangen speciale beloningen',
    ],
    boostEarningsTitle: 'Verhoog je verdiensten',
    boostEarningsRules: [
        'Voltooi uitdagingen voor bonussen',
        'Word lid van onze Telegram community',
        'Blijf actief voor maximale beloningen',
    ],
    challenges: 'Uitdagingen',
    telegramChallenge: 'Telegram uitdaging',
    emailChallenge: 'E-mail uitdaging',
    connectTelegram: 'Verbind Telegram',
    shareEmail: 'Deel e-mail',
    telegramSuccess:
        '🎉 Gefeliciteerd! Je ontvangt nu een permanente 10% bonus op alle beloningen!',
    telegramPrompt: 'Verbind je Telegram account voor een permanente 10% bonus op alle beloningen!',
    emailSuccess: '🎉 Gefeliciteerd! Je ontvangt nu een permanente 10% bonus op alle beloningen!',
    emailPrompt: 'Deel je e-mail voor een permanente 10% bonus op alle beloningen!',
    connectEmail: 'Verbind e-mail',
    cancel: 'Annuleren',
    emailPrivacy:
        'We gebruiken je e-mail alleen voor belangrijke updates en beloningsnotificaties.',
    connectYourEmail: 'Verbind je e-mail',
    emailBonus:
        '🎉 Ontvang een permanente 10% bonus op alle beloningen door je e-mail te verbinden!',
    enterValidEmail: 'Voer een geldig e-mailadres in',
    emailAddress: 'E-mailadres',
    errorSavingEmail: 'Fout bij opslaan e-mail. Probeer het opnieuw.',
    claimButton: 'Claimen',
    earnedReward: 'Verdiende beloning',
    rewardValue: '{{amount}} Punten',
    claimingReward: 'Claimen...',
    claimSuccess: 'Succesvol {{amount}} punten geclaimd!',
    claimError: 'Beloning claimen mislukt. Probeer het opnieuw.',
    privacyDisclaimer:
        'Coinomi verzamelt geen persoonlijke gegevens; een derde partij systeem beheert veilig de punten en sociale verbindingen.',
    streakBonus: 'Streak bonus',
    streakDays: '{{days}}/5 Dagen',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10% Extra',
    streakDescription: 'Claim 5 dagen op rij voor maximale bonus',
    streakToday: 'Vandaag',
    streakMissed: 'Gemist',
    streakComplete: 'Voltooid',
    streakActive: 'Actieve streak',
    streakLost: 'Streak verloren',
    streakNext: 'Volgende',
    home: 'Home',
    currentStreak: 'Huidige streak',
    totalClaims: 'Totaal claims',
    userStats: 'Jouw statistieken',
    referrals: 'Verwijzingen',
    referralProgram: 'Verwijzingsprogramma',
    howReferralWorks: 'Hoe verwijzingen werken:',
    referralSteps: [
        'Deel je verwijzingslink met vrienden',
        'Wanneer ze zich aanmelden via jouw link, worden ze jouw verwijzing',
        'Verdien bonuspunten voor elke actieve verwijzing',
        'Volg je verwijzingen en verdiensten hier',
    ],
    referralRewards: 'Verwijzingspunten worden toegekend:',
    referralBonuses: [
        '100 punten per verwijzing',
        '10% van alle punten die je verwijzing verdient',
    ],
    yourReferralLink: 'Jouw verwijzingslink',
    copyToClipboard: 'Kopiëren naar klembord',
    linkCopied: 'Link gekopieerd naar klembord!',
    totalReferrals: 'Totaal verwijzingen',
    yourReferralCode: 'Jouw verwijzingscode',
    referralCodeCopied: 'Verwijzingscode gekopieerd!',
    editReferralCode: 'Verwijzingscode bewerken',
    editReferralCodeInstructions:
        'Kies een nieuwe verwijzingscode. Moet minimaal 5 tekens bevatten en mag letters en cijfers bevatten.',
    newReferralCode: 'Nieuwe verwijzingscode',
    referralCodeRequirements: 'Minimaal 5 tekens, alleen letters en cijfers',
    updating: 'Bijwerken...',
    update: 'Bijwerken',
    referralCodeTaken: 'Deze verwijzingscode is al in gebruik',
    haveReferralCode: 'Heb je een verwijzingscode?',
    enterReferralCodePrompt:
        'Als iemand je heeft verwezen, voer hier hun code in om accounts te koppelen.',
    enterReferralCode: 'Voer verwijzingscode in',
    enterReferralCodeInstructions: 'Voer de verwijzingscode in die met je is gedeeld.',
    referralCode: 'Verwijzingscode',
    referralCodeFormat: 'Alleen letters en cijfers',
    submitting: 'Verzenden...',
    submit: 'Verzenden',
    enterCode: 'Voer code in',
    pleaseAddtoken: 'Voeg token parameter toe aan URL',
    authenticationError: 'Er is een fout opgetreden tijdens authenticatie',
    noUserFound: 'Geen gebruiker gevonden',
    userNotFoundMessage: 'Kan gebruikersgegevens niet vinden',
    backToHome: 'Terug naar home',
    retry: 'Opnieuw proberen',
    baseMultiplier: 'Basis vermenigvuldiger',
    telegramBonus: 'Telegram bonus',
    referralChallenge: 'Verwijzingsuitdaging',
    referralChallengePrompt:
        'Nodig vrienden uit en verdien bonuspunten! Ontvang 100 punten per verwijzing plus 10% van hun verdiensten.',
    startReferring: 'Begin met verwijzen',
    referralSuccess:
        '🎉 Gefeliciteerd! Je hebt succesvol gebruikers verwezen en verdient bonuspunten!',
    unranked: 'Niet gerangschikt',
    noPlayersYet: 'Wees de eerste die zich aanmeldt!',
    shareVia: 'Delen via',
    shareOn: 'Delen op {{network}}',
    shareInviteText:
        '🚀 Ik verdien gratis crypto met @CoinomiWallet!\n\nDownload Coinomi op coinomi.com/downloads en voer mijn verwijzingscode {{referralCode}} in om een bonus te krijgen wanneer je je aansluit bij #Coinomi Rewards in de app.',
    yourStatsThisWeek: 'Jouw statistieken deze week',
    pointsMultiplier: 'Puntenvermenigvuldiger',
    yourRank: 'Jouw rang',
    rewards: 'Beloningen',
    daily: 'Dagelijks',
    weekly: 'Wekelijks',
    claimRewards: 'Claim beloningen',
    copy: 'Kopiëren',
    // Twitter Challenge
    twitterChallenge: 'Twitter Uitdaging',
    connectTwitter: 'Verbind met Twitter',
    twitterSuccess:
        '🎉 Gefeliciteerd! Je ontvangt nu een permanente bonus van 10% op alle beloningen!',
    twitterPrompt:
        'Koppel je Twitter-account om een permanente bonus van 10% op alle beloningen te krijgen!',
    pleaseAddUserId: 'Voeg een userId-parameter toe aan de URL',
    emailChallengePrompt: 'Deel je e-mail voor een permanente 10% bonus op alle beloningen!',
    emailChallengeSuccess:
        '🎉 Verbonden! Je ontvangt nu een permanente 10% bonus op alle beloningen!',
    followKoalaWalletChallenge: 'Volg @coinomiWallet op Twitter om ons te steunen!',
    twitterAuthSuccessTitle: 'Twitter succesvol verbonden!',
    twitterAuthSuccessMessage:
        'Je Twitter-account is succesvol verbonden. Je kunt nu doorgaan met de app.',
    continueToApp: 'Doorgaan naar app',
    twitter_like: 'Tweet geliket',
    twitter_retweet: 'Tweet geretweet',
    disconnect: 'Verbreek verbinding',
    followCoinomiWallet: 'Volg @coinomiWallet op Twitter om ons te steunen!',
    connectedBonus: '🎉 Verbonden! Je ontvangt nu een permanente 10% bonus op alle beloningen!',
};
